const CartPayments = {

    init() {
        let self = this;
        
        if(document.querySelectorAll('.js-cart-group').length > 0) {
            self._create();
        }
    },

    _create() {
        let self = this;

        document.querySelectorAll('.js-cart-group:not(data-initialized)').forEach(node => {
            node.dataset.initialized = '1';

            node.querySelectorAll('.js-cart-description input').forEach(input => {
                input.addEventListener('change', () => {
                    self._hideAllNodes();
                    if(event.target.checked) {
                        input.closest('.js-cart-description').classList.add('js-cart-description--visible');
                    }
                    else {
                        input.closest.classList.remove('js-cart-description--visible');
                    }
                });
            });
        });

    },

    _hideAllNodes() {
        let self = this;
        let nodes = document.querySelectorAll('.js-cart-description');
        nodes.forEach(item => {
            item.classList.remove('js-cart-description--visible');
        });

    }
}

CartPayments.init();

document.addEventListener('LokiRequestEnd', function () {
    CartPayments.init();
});


const FacturationDisplayer =  {
    init() {
        let self = this;

        if(document.querySelector('.js-facturation-checkbox')) {
            self._create();
        }
    },

    _create() {
        let self = this;

        let input = document.querySelector('.js-facturation-checkbox');

        if(! input.dataset.dataInitialized) {
            input.dataset.initialized = '1';

            

            input.addEventListener('change', () => {
                self._toggleNode();
            });
        }
            
    },

    _toggleNode() {
        let node = document.querySelector('.js-facturation');
        
        node.classList.toggle('js-facturation--visible');
    }
}


FacturationDisplayer.init();

document.addEventListener('LokiRequestEnd', function () {
    FacturationDisplayer.init();
});


window.jarvisCeskaPostaPostSearch = function () {
    var search = document.querySelector('.js-ceska-posta-search');
    var input = search.querySelector('input');
    var ul = search.querySelector('ul');
    var li = ul.getElementsByTagName('li');
    var empty = search.querySelector('.js-ceska-posta-search__result-empty');

    var filter = input.value.toUpperCase();
    if (filter) {
        var count = 0;
        for (var i = 0; i < li.length; i++) {
            var value = li[i].textContent || li[i].innerText;
            var match = value.toUpperCase().indexOf(filter) > -1;

            if (match) {
                count ++;
                li[i].classList.add('active');
            } else {
                li[i].classList.remove('active');
            }
        }

        empty.classList[count ? 'remove' : 'add']('active');

        // click handler
        var closeOnClickOut = function (event) {
            if (! event.target.closest('.js-ceska-posta-search')) {
                document.body.removeEventListener('click', closeOnClickOut);

                jarvisCeskaPostaPostClearResults();
                jarvisCeskaPostaPostClearSearch();
            }
        };
        document.body.addEventListener('click', closeOnClickOut);

        return;
    }

    jarvisCeskaPostaPostClearResults();
}

window.jarvisCeskaPostaPostClearSearch = function () {
    var search = document.querySelector('.js-ceska-posta-search');
    var input = search.querySelector('input');
    input.value = '';

    jarvisCeskaPostaPostClearResults();
}

window.jarvisCeskaPostaPostClearResults = function () {
    var search = document.querySelector('.js-ceska-posta-search');
    var li = search.getElementsByTagName('li');
    var empty = search.querySelector('.js-ceska-posta-search__result-empty');

    for (var i = 0; i < li.length; i++) {
        li[i].classList.remove('active');
    }
    empty.classList.remove('active');
}

window.jarvisCeskaPostaPostSelect = function (input) {
    jarvisCeskaPostaPostClearResults();

    var data = JSON.parse(input.dataset.post);

    document.getElementById('transport_ceska_posta_post_id').value = data.postCode;
    document.getElementById('transport_city').value = data.city;
    document.getElementById('transport_house_number').value = 'CP ' + data.postCode;
    document.getElementById('transport_postcode').value = data.postCode;
    document.getElementById('transport_street').value = data.address;

    jarvisCeskaPostaPostClearSearch();

    LokiController.submitForm(input);
}